/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_CREDIT_NOTE_DATA,
  SET_CREDIT_NOTE_ANALYSIS_DATA,
  SET_VENDOR_LIST,
  SET_RET_PERIOD,
  SET_CLEAR_GRAPH,
  SET_INVOICE_COUNT
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  creditNoteData: [],
  creditNoteAnalysisData: [],
  vendorListData: [],
  ReturnPeriodData: [],
  invoiceCount: ""
};

/* eslint-disable default-case, no-param-reassign */
const CreditNoteAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_CREDIT_NOTE_DATA:
      return {
        ...state,
        creditNoteData: action.creditNoteData
      };
    case SET_CREDIT_NOTE_ANALYSIS_DATA:
      return {
        ...state,
        creditNoteAnalysisData: action.creditNoteAnalysisData
      };
    case SET_VENDOR_LIST:
      return {
        ...state,
        vendorListData: action.vendorListData
      };
    case SET_RET_PERIOD:
      return {
        ...state,
        ReturnPeriodData: action.ReturnPeriodData
      };
    case SET_INVOICE_COUNT:
      return {
        ...state,
        invoiceCount: action.invoiceCount
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        ReturnPeriodData: [],
        invoiceCount: "",
        vendorListData: [],
        creditNoteAnalysisData: [],
        creditNoteData: []
      };
    default:
      return state;
  }
};

export default CreditNoteAnalysisReducer;
